export const cursor = {
  NONE: '',
  HOVERING: 'hovering',
  VIDEO: 'video',
}
